if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
  super();

  this.form = this.querySelector('form');
  if (!this.form) return; // safety

  // enable the hidden variant id input if present
  const idInput = this.variantIdInput;
  if (idInput) idInput.disabled = false;

  this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

  this.cart =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');

  // be flexible about button selector
  this.submitButton = this.querySelector('[type="submit"], button[name="add"]');
  this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

  if (document.querySelector('cart-drawer') && this.submitButton) {
    this.submitButton.setAttribute('aria-haspopup', 'dialog');
  }

  this.hideErrors = this.dataset.hideErrors === 'true';
}


onSubmitHandler(evt) {
  evt.preventDefault();

  const btn = this.submitButton || this.querySelector('[type="submit"], button[name="add"]');
  if (btn && btn.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  if (btn) {
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', true);
  }

  const spinner = this.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = btn ? btn.querySelector('.sold-out-message') : null;
        if (!soldOutMessage || !btn) return;

        btn.setAttribute('aria-disabled', true);
        if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
      }
      this.error = false;

      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        CartPerformance.measure("add:paint-updated-sections", () => {
          this.cart.renderContents(response);
        });
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      const btn2 = this.submitButton || this.querySelector('[type="submit"], button[name="add"]');
      if (btn2) {
        btn2.classList.remove('loading');
        if (!this.error) btn2.removeAttribute('aria-disabled');
        btn2.disabled = false;
      }

      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }

      const spinner2 = this.querySelector('.loading__spinner');
      if (spinner2) spinner2.classList.add('hidden');

      CartPerformance.measureFromEvent("add:user-action", evt);
    });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
